import { motion } from "framer-motion";
import lava_1 from "../assets/lava_1.svg";
import lava_2 from "../assets/lava_2.svg";
import BouncyImageTooltip from "./BouncyImageTooltip"; // Assuming this component is ready
import { useState } from "react";
// NEW: Import the icons you need
import { FaGithub, FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";

// --- Animation Variants (Unchanged) ---
const pageVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1,
    },
  },
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 15,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: "easeOut",
      duration: 0.5,
    },
  },
};

// --- A small, self-contained sidebar component ---
const SocialSidebar = () => {
  return (
    <aside className="social-sidebar">
      <a href="#" className="social-icon" aria-label="GitHub">
        <FaGithub />
      </a>
      <a
        href="https://www.linkedin.com/in/lavanya-kulkarni-bb38a1282/"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="LinkedIn"
      >
        <FaLinkedin />
      </a>
      <a href="#" className="social-icon" aria-label="Twitter">
        <FaTwitter />
      </a>
      <a
        href="https://www.instagram.com/lavanya._k__/"
        target="_blank"
        rel="noreferrer"
        className="social-icon"
        aria-label="Instagram"
      >
        <FaInstagram />
      </a>
    </aside>
  );
};

const HomePage = ({ goToPage, onLogoClick }) => {
  const [logoSrc, setLogoSrc] = useState(lava_1);

  const handleLinkClick = (e, pageIndex) => {
    e.preventDefault();
    goToPage(pageIndex);
  };

  const navLinks = [
    { title: "ABOUT ME", pageIndex: 1 },
    { title: "WORK EXPERIENCE", pageIndex: 2 },
    { title: "LET'S CONNECT?", pageIndex: 3 },
  ];

  return (
    // NEW: A wrapper to hold the sidebar and main content side-by-side
    <div className="homepage-container">
      <SocialSidebar />
      {/* Your original motion.div now sits next to the sidebar */}
      <motion.div
        className="page home-page"
        variants={pageVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div className="intro-text" variants={itemVariants}>
          <strong>Hi, I am</strong>
        </motion.div>

        <motion.div
          className="logo-main"
          variants={itemVariants}
          onClick={onLogoClick}
          onMouseEnter={() => setLogoSrc(lava_2)}
          onMouseLeave={() => setLogoSrc(lava_1)}
        >
          <BouncyImageTooltip>
            <img className="logo-svg" src={logoSrc} alt="Lava Logo" />
          </BouncyImageTooltip>
        </motion.div>

        <motion.div className="nav-links" variants={itemVariants}>
          {navLinks.map((link) => (
            <a
              key={link.title}
              href="#"
              className="nav-link"
              onClick={(e) => handleLinkClick(e, link.pageIndex)}
            >
              {link.title}
            </a>
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default HomePage;
